import { theme } from 'shared/styles/theme';
import { StarsSelect } from 'shared/ui/StarsSelect/StarsSelect';
import { Flex, Label } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { Field, type FieldProps } from 'formik';

type Props = {
  maxValue: number;
  name: string;
  label?: string;
  comment?: string;
};

export const FormStarsSelect = ({ maxValue, name, label, comment }: Props) => (
  <Field name={name}>
    {({ form, field, meta }: FieldProps) => (
      <Flex flexDirection='column' gap={10}>
        {comment ? (
          <Flex flexDirection='column' gap={5}>
            <Label>{label}</Label>
            <Typography fontSize={theme.fontSizes['14']}>{comment}</Typography>
          </Flex>
        ) : (
          <Label>{label}</Label>
        )}
        <StarsSelect
          maxValue={maxValue}
          onChange={(value) => form.setFieldValue(name, value)}
          value={field.value}
          errorMessage={meta.error && meta.touched ? meta.error : ''}
        />
      </Flex>
    )}
  </Field>
);
